export default __webpack_public_path__ + "static/media/set10.1b70d224.jpeg";